<template>
    <div id="">
      <div class="bg">
        <div class="white flex flex-column hcenter " style="font-family: TruenoBd;height: 100%;padding-left: 10%;">
          <div class="pageTitle" style="text-align:left;font-size:36px !important"><p class="mb0">“以技术和创造力，</p> <p style="padding-left:10px;line-height:43px">拓展人类食物来源的边界”</p>
            </div>
          <div class="subPageTitle mt2" style="letter-spacing: 2px;max-width:50%;text-align:left;padding-left:10px;font-size:14px">EXPAND THE BOUNDARIES OF HUMAN FOOD SOURCES WITH TECHNOLOGY AND CREATIVITY</div>
        </div>
        
      </div>
      <div class="aboutUs">
         <div class="white flex flex-column hcenter " style="font-family: TruenoBd;padding-left: 10%;height: 100%" >
            <div class="pageTitle opacity0" :class="scrollY>290?'movein':''">公司介绍</div>
            <div class="subPageTitle opacity0" :class="scrollY>390?'movein':''">/ABOUT US</div>
            <div class="subPageContent mt6 opacity0" :class="scrollY>390?'movein':''" style="font-size:16px">
              一兮生物是一家专注于合成生物学领域的技术与产品研发公司，从自然存在的生命过程中获取灵感，利用合成生物学技术设计、构建基因代谢网络，应用于食品、药物、工业原料等的合成。
            </div>
            <div class="goDetail green mt8 opacity0" :class="scrollY>590?'movein':''" @click="$router.push({path:'/about'})">
              查看详情 <span>➝</span>
            </div>
          </div>
      </div>
      <div class="advantage">
        <div class="white flex vcenter " style="font-family: TruenoBd;height: 100%;justify-content:center">
          <div class="box m2 opacity0" :class="scrollY>900?'movein':''">
            <img src="../assets/main/advantage1.png">
            <div>
              <span>合成生物学平台</span>
              <div class="more"><div @click="$router.push({path:'/tech'})">MORE</div></div>
            </div>
          </div>
          <div class="box m2 opacity0" :class="scrollY>900?'movein':''">
            <img src="../assets/main/advantage2.png">
            <div>
              <span>交互式发酵平台</span>
              <div class="more"><div @click="$router.push({path:'/tech'})">MORE</div></div>
            </div>
          </div>
          <div class="ml8 mt2 techAdvantage">
            <div class="pageTitle opacity0" style="color:#111D2B"  :class="scrollY>900?'movein':''">技术优势</div>
            <div class="subPageTitle opacity0" style="color:#111D2B" :class="scrollY>1000?'movein':''">/TECHNOLOGY ADVANTAGE</div>
            <div class=" mt6 opacity0" style="color:#111D2B;font-size:16px;line-height: 32px;" :class="scrollY>1100?'movein':''">
              从生物空间中挖掘信息<br>
              从自然界中获取灵感<br>
              用生物技术谱写生命
            </div>
            <div class="goDetail outline mt8 opacity0" :class="scrollY>1300?'movein':''" @click="$router.push({path:'/tech'})">
              查看详情 <span>➝</span>
            </div>
          </div>
        </div>
      </div>
      <div class="industrial">
        <div class="white flex flex-column hcenter vcenter " style="font-family: TruenoBd;height: 100%" >
          <div class="pageTitle opacity0" style="color:#111D2B" :class="scrollY>1700?'movein':''">产业布局</div>
          <div class="subPageTitle opacity0" style="color:#111D2B" :class="scrollY>1700?'movein':''">/INDUSTRIAL LAYOUT</div>
          <div class="notice opacity0" :class="scrollY>1800?'movein':''">
            利用合成生物学，为人类健康保驾护航
          </div>
          <div class="goDetail outline hoverGreen mt8 opacity0" style="border: 1px solid rgba(17, 29, 43, 0.34)" :class="scrollY>1900?'movein':''" @click="$router.push({path:'/product'})">
              查看详情 <span>➝</span>
          </div>
          <img class="mt8 industrialImg opacity0" src="../assets/main/industrial.png" :class="scrollY>2000?'movein':''" >
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return{
      scrollY:0
    }
  },
  mounted () {
    window.addEventListener('scroll',(e)=>{
      this.scrollY = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    })
    $('.learnmore').on({
      mouseover: function () {
        $(this).addClass('hover')
      },
      mouseout: function () {
        $(this).removeClass('hover')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.bg{
  width: 100%;
  height: 957px;
  background-image: url("../assets/main/bg.png");
  background-position: 95% 50%;
  background-size: cover;
  cursor: default;
  text-align: center;
}
.aboutUs{
  width: 100%;
  height: 779px;
  background: #111D2B;
  background-image: url("../assets/main/aboutUs.png");
  background-position: 50% 50%;
  background-size: cover;
  //background-size: 100% 100%;
}
@media screen and (max-width: 750px)  {
  .bg{background-position: 70% 50%;}
  .aboutUs{background-position: 70% 50%;}
  .advantage>div{
    padding-left:0 !important;
  }
}
.advantage{
  width: 100%;
  padding:89px 0;
  background: #00BD89;
  div{
    justify-content: center;
    flex-wrap: wrap;
    .box{
      width: 360px;
      height: 338px;
      background: #111D2B;
      box-shadow: 27px 27px 33px 0px rgba(17,29,43,0.22);
      border-radius: 11px;
      display: flex;
      flex-direction: column;
      img{
        width: 100%;
        height: 262px;
      }
      div{
        display: flex;
        height: 76px;
        align-items: center;
        span{
          font-size: 22px;
          font-weight: 500;
          color: #FFFFFF;
          flex:2;
          text-align: center;
          cursor:default;
        }
        .more{
          flex:1;
          
          div{
            border:1px solid rgba(255, 255, 255, 0.42);
            text-shadow: 17px 17px 21px rgba(17, 29, 43, 0.22);
            width: 67px;
            height: 28px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            cursor: pointer;
          }
        }
      }
    }
  }
}
.industrial{
  width:100%;
  padding:10% 0;
  background: #F2F6FA;
  div{
    .notice{
      font-weight: 400;
      color: #00BD89;
      margin-top:81px;
    }
    
  }
}




@media screen and (max-width: 1700px){
  .techAdvantage{
    margin-left: 47px !important;
    width: 360px;
  }
  
}
@media screen and (max-width: 1310px){
  .advantage>div{
    justify-content: left !important;
  }
  
}

@media screen and (max-width: 960px){
  .pageTitle {
    font-size: 40px !important;
  }
  .subPageTitle{
    font-size: 14px !important;
  }
}
@media screen and (max-width: 640px){
  .pageTitle {
    font-size: 32px !important;
  }
  .subPageTitle{
    font-size: 14px !important;
  }
}
@media screen and (max-width: 480px){
  .pageTitle {
    font-size: 32px !important;
  }
  .subPageTitle{
    font-size: 14px !important;
  }
  .bg>.white{
    padding-left:5% !important;
  }
}
::v-deep{
  #navbar{
    background: none !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/home.vue